import { render, staticRenderFns } from "./CasePyohemia.vue?vue&type=template&id=44d87ffb&scoped=true"
import script from "./CasePyohemia.vue?vue&type=script&lang=js"
export * from "./CasePyohemia.vue?vue&type=script&lang=js"
import style0 from "./CasePyohemia.vue?vue&type=style&index=0&id=44d87ffb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d87ffb",
  null
  
)

export default component.exports